/* eslint-disable react/no-array-index-key */
/* eslint-disable import/order */
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import Icon from '@mdi/react'
import { mdiMicrosoftExcel } from '@mdi/js'

import consts from '../../../util/consts'
import styles from '../../../resources/theme/users'
import Paginate from '../../components/Pagination'
import { team, makeRelatory } from '../TeamProdutivityRelatoryActions'
import { exportFormatedMoney, useQueryParams } from '../../../util/utils'
import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'

function Produtivity({ match }) {
  const classes = filterStylesComponents()
  const dispatch = useDispatch()
  const location = useLocation()

  const { id } = match.params

  // Filtros vêm da URL (mesma fonte de verdade da listagem), não do redux.
  const query = useQueryParams(location.search)
  const filters = useMemo(() => {
    // eslint-disable-next-line no-unused-vars
    const { page, rows, ...rest } = query
    return rest
  }, [location.search])

  const items = useSelector(state => state.team_produtivity_relatory.items)
  const subItems = useSelector(
    state => state.team_produtivity_relatory.subItems
  )
  const subTotalSize = useSelector(
    state => state.team_produtivity_relatory.subTotalSize
  )
  const subPage = useSelector(state => state.team_produtivity_relatory.subPage)
  const subPerPage = useSelector(
    state => state.team_produtivity_relatory.subSizePerPage
  )

  const [subRowsPerPage, setSubRowsPerPage] = useState(
    subPerPage || consts.DEFAULT_PAGINATION
  )

  const onMovePage = (event, newPage) => {
    dispatch(team(id, newPage + 1, subRowsPerPage, filters))
  }

  useEffect(() => {
    dispatch(team(id, 1, subRowsPerPage, filters))
  }, [subRowsPerPage, location.search])

  const handleChangeRowsPerPage = event => {
    setSubRowsPerPage(event.target.value)
  }

  const makeReport = () => {
    const current = items.find(item => String(item.id) === id)
    const teamName = current?.team
      ? current.team.replace(' ', '_')
      : `equipe_${id}`

    dispatch(
      makeRelatory(
        filters,
        `make-relatory-team-produtivity/${id}`,
        `${teamName}_productivity_relatory`
      )
    )
  }

  return (
    <BaseRelatoryPage
      btnReturn
      btnReturnPath={`/relatory-team-produtivity${location.search}`}
      title="Equipe"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BaseFilter>
            <Grid item xs={12}>
              <Grid container justifyContent="flex-end" alignItems="center">
                <IconButton onClick={makeReport} className={classes.btnAdd}>
                  <Icon path={mdiMicrosoftExcel} size={1} />
                  Download
                </IconButton>
              </Grid>
            </Grid>
          </BaseFilter>
        </Grid>

        <Grid item xs={12}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCellHeader>ID</StyledTableCellHeader>
                  <StyledTableCellHeader align="center">
                    Data
                  </StyledTableCellHeader>
                  <StyledTableCellHeader>Tipo de Serviço</StyledTableCellHeader>
                  <StyledTableCellHeader>Nome do Cliente</StyledTableCellHeader>
                  <StyledTableCellHeader>Endereço</StyledTableCellHeader>
                  <StyledTableCellHeader align="center">
                    Valor
                  </StyledTableCellHeader>
                  <StyledTableCellHeader align="center">
                    Valor do Técnico
                  </StyledTableCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {subItems.map((item, index) => (
                  <TableRow key={index}>
                    <StyledTableCellBody>{item.id}</StyledTableCellBody>
                    <StyledTableCellBody align="center">
                      {item.date}
                    </StyledTableCellBody>
                    <StyledTableCellBody>{item.type}</StyledTableCellBody>
                    <StyledTableCellBody>
                      {item.client_name}
                    </StyledTableCellBody>
                    <StyledTableCellBody>{item.address}</StyledTableCellBody>
                    <StyledTableCellBody align="center">
                      {exportFormatedMoney(item.value)}
                    </StyledTableCellBody>
                    <StyledTableCellBody align="center">
                      {exportFormatedMoney(item.commission ?? 0)}
                    </StyledTableCellBody>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Paginate
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={subRowsPerPage}
            rows={subTotalSize}
            page={subPage - 1}
            handleChangePage={onMovePage}
          />
        </Grid>
      </Grid>
    </BaseRelatoryPage>
  )
}

export default withStyles(styles)(Produtivity)
